import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}`

const getDataNivel = (query, params) => http.get(`${api}/operation/pharmedis-capita/${params}`, { params: { ...query } })

export {
  getDataNivel
}
